import palette from './palette';
import typography from './typography';
import breakpoints from './breakpoints';

const foundations = {
  palette,
  typography,
  breakpoints
};

export default foundations;
